/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1SettingsErpfieldsQueryResponse } from '../../types/GetV1SettingsErpfields.ts'

export const getV1SettingsErpfieldsQueryKey = () => [{ url: '/v1/settings/erpfields' }] as const

export type GetV1SettingsErpfieldsQueryKey = ReturnType<typeof getV1SettingsErpfieldsQueryKey>

/**
 * {@link /v1/settings/erpfields}
 */
export async function getV1SettingsErpfields(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1SettingsErpfieldsQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/settings/erpfields`, ...requestConfig })
    return res
}

export function getV1SettingsErpfieldsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1SettingsErpfieldsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1SettingsErpfieldsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1SettingsErpfieldsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1SettingsErpfields(config)
        },
    })
}

/**
 * {@link /v1/settings/erpfields}
 */
export function useGetV1SettingsErpfields<
    TData = ResponseConfig<GetV1SettingsErpfieldsQueryResponse>,
    TQueryData = ResponseConfig<GetV1SettingsErpfieldsQueryResponse>,
    TQueryKey extends QueryKey = GetV1SettingsErpfieldsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1SettingsErpfieldsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1SettingsErpfieldsQueryKey()

    const query = useQuery(
        {
            ...getV1SettingsErpfieldsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
